import React, { createContext, useContext, useEffect, useState } from 'react';
import ModalTask from 'components/Organisms/Modals/ModalTask/ModalTask';
import iconCortPng from 'assets/images/home.png';
import Step1 from './Step1/Step1';
import { Button } from 'antd';
import Step2 from './Step2/Step2';
import {
  Entity,
  Loan,
  LoanDocState,
  Task,
  TaskResponse,
  TaskState
} from '../../../../../gql/graphql';
import { useGetTaskResponsesByTask } from '../../../../../services/task/querys';
import StateTag from 'components/Atoms/Tags/StateTag/StateTag';
import { findTaskRules } from '../../RulesTaskCards.constanst';
import { ModuleKeys } from 'services/task/modules-keys.constanst';
import { TaskOpenModalContext } from '../../../Private';
import CircleTag from 'components/Atoms/Tags/CircleTag/CircleTag';
import { useGetLoanDocByLoan } from '../../../../../services/loan/querys';
import { useModalContext } from '../../../../../sentry/contexts/useModalContext';
import { LoanContext, ViewLoanDetailsContext } from '../../Dashboard';

export const TaskContext = createContext<Task | {}>({});
export const EntityContext = createContext<Entity | {}>({});

interface Props {
  task: Task;
}

const Insurance = ({ task }: Props) => {
  const loan: Loan | any = useContext(LoanContext);
  const { value: openContext, setHandler }: any = useContext(TaskOpenModalContext);
  const { setState: setStateViewLoanDetails }: any = useContext(ViewLoanDetailsContext);

  const { data: loanDocs } = useGetLoanDocByLoan({ variables: { loanId: loan._id } });
  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } },
    pause: true
  });

  const [isModalTaskVisible, setModalTaskVisible] = useState(false);
  const [isReview, setIsReview] = useState(false);
  const [step, setStep] = useState(1);
  const [responsesStep1, setResponsesStep1] = useState<any>();
  const [responseStep2, setResponseStep2] = useState<TaskResponse>();
  const [responseStep2Docs, setResponseStep2Docs] = useState<TaskResponse>();
  const [entity, setEntity] = useState<Entity | any>();
  const [optionStep1Select, setOptionStep1Select] = useState<{ id: number; title: string; }>();
  const [countDocs, setCountDocs] = useState<number>();

  useEffect(() => {
    getTaskResponses({ requestPolicy: 'network-only' });
  }, [])

  useEffect(() => {
    if (openContext === ModuleKeys.INSURANCE) {
      setModalTaskVisible(true);
      setHandler();
    } else if (!!openContext)
      setModalTaskVisible(false);
  }, [openContext]);

  useModalContext({ isModalVisible: isModalTaskVisible, modalKey: 'insurance', task, step });

  useEffect(() => {
    if (isModalTaskVisible){
      setStep(1);
      getTaskResponses({ requestPolicy: 'network-only' });
    }
  }, [isModalTaskVisible])

  useEffect(() => {
    const step1: any = taskResponses?.filter((item) => item.step === 1);
    setResponsesStep1(step1);

    //if (step1?.key === 'no') setStep(2);

    const step2: any = taskResponses?.find((item) => item.step === 2);
    
    const step2Docs: any = taskResponses?.find((item) => item.step === 2 && (item.files?.length ?? 0) > 0)
    setResponseStep2(step2);
    setResponseStep2Docs(step2Docs);
    setIsReview(step2?.state === TaskState.Review && task.state === TaskState.Review);

    if (step2Docs?.files && step2Docs.files.length > 0) {
      setCountDocs(1);
    }
  }, [taskResponses]);

  const onHelpDocs = () => {};

  const getFilesCircle = () => {
    const allFiles = responseStep2Docs?.files || [];
    if (allFiles.length === 0) return [];

    const filesWithoutError = allFiles.filter((item: any) => item.state !== 'request_error');
    return filesWithoutError;
  };

  const getTotalApprovedTracker = () => {
    const filesWithoutError = responseStep2Docs?.files?.filter((item: any) => item.state !== 'request_error') || [];
    return filesWithoutError.filter((item: any) => item.state !== 'draft').length;
  };

   const resetTask = (openModal: Function) => {
    setStep(1);
    getTaskResponses({ requestPolicy: 'network-only' });
    openModal(true);
  }
  
  const { taskName } = findTaskRules(ModuleKeys.INSURANCE);
  
  //Cuando el contact es aprobado por el processing team y no hay un loan documents de insurance
  //El estado se muestra en Review, no en Approved
  const isLoanDocInsurance = loanDocs?.find(item => item.key === 'insurance');
  const isContact = responsesStep1?.find((item: any) => item.key === 'contact')?.state === TaskState.Approved;

  const transformState = !isLoanDocInsurance && task?.metadata?.contactedApproved && task.state === TaskState.Approved? TaskState.Review: task.state;
  //Misma lógica en el cardInsurance
  const isAwaitingAction = task?.metadata?.reviewRename === 'MANUAL ACTION' && !isContact;
  
  const canNavigateToStep = (targetStep: number) => {
    if (targetStep === 1) return true;
    if (targetStep === 2) {
      if (optionStep1Select && optionStep1Select.id === 1) return false;
      return optionStep1Select !== undefined;
    }
    return false;
  }
  const renderTracker = () => (
    <div style={{ height: '100%' }}>
      <span className='title-summary'>Task summary</span>
      <div className="mt-20">
        <div className="placeholder">
          My insurance is{' '}
          <p className="tag-blue" style={{ width: 'fit-content' }}>
            {transformState === TaskState.Approved? 'approved': 'not approved'}
          </p>
        </div>
        {responseStep2Docs &&
          <>
            <p
              className="placeholder"
              style={{ marginTop: 45, fontWeight: 500 }}
            >
              Document status{' '}
            </p>
            {taskResponses && (
              <div className="owners-tags mt-5">
                <span>
                  {getTotalApprovedTracker()}/{getFilesCircle().length} documents submitted
                </span>
              </div>
            )}

            <div className="mt-10 circles-tags">
              {getFilesCircle().map((_response, index) => (
                <CircleTag 
                  key={index} 
                  state={_response?.state?.toUpperCase() || 'DRAFT'} 
                  tagKey={_response?.state?.toUpperCase() || 'DRAFT'} 
                  isIconState={true}
                />
              ))}
            </div>
          </>
        }
      </div>
    </div>
  );

  const isInsuranceApproved = transformState === TaskState.Approved && isLoanDocInsurance?.state === LoanDocState.Approved;

  return (
    <TaskContext.Provider value={task}>
      <EntityContext.Provider value={entity}>
        <ModalTask
          task={task}
          visible={isModalTaskVisible}
          handlerSetVisibile={setModalTaskVisible}
          isConfirmModalClose={transformState !== TaskState.Approved && !isReview}
          disabledDots={false}
          canNavigateToStep={canNavigateToStep}
          stepAlwaysDraft={transformState === TaskState.Approved && isLoanDocInsurance?.state === LoanDocState.Approved? undefined: 1}
          stepAlwaysApproved={transformState === TaskState.Approved && isLoanDocInsurance?.state === LoanDocState.Approved? 1: undefined}
          responses={taskResponses}
          renderButtonTrigger={(openModal: any) => (
            <>
              {transformState !== TaskState.Review && transformState !== TaskState.Approved &&
                <Button
                  className={`button-open-modal button-open-modal-${isAwaitingAction ? 'AWAITING_ACTION' : transformState}`}
                  onClick={() => openModal(true)}
                >
                  {(transformState === TaskState.Incomplete) ?
                    'Complete task' :
                    (transformState === TaskState.RequestError) ? 'Resolve issues' :
                      'Begin Task'
                  }
                </Button>
              }
              {(transformState === TaskState.Review || transformState === TaskState.Approved) && !isInsuranceApproved &&
                <Button
                  className={`button-open-modal button-open-modal-${isAwaitingAction ? 'AWAITING_ACTION' : transformState}`}
                  onClick={() => resetTask(openModal)}
                >
                  Change insurance type
                </Button>
              }
              {isInsuranceApproved &&
                <Button
                  className={`button-open-modal button-open-modal-${isAwaitingAction ? 'AWAITING_ACTION' : transformState}`}
                  onClick={() => setStateViewLoanDetails(true)}
                >
                  View insurance documents
                </Button>
              }
            </>
          )}
          header={{
            title: <span>{taskName.toUpperCase()}</span>,
            actionLeft: (
              isReview ? 
                <StateTag 
                  isOtherState={isAwaitingAction} 
                  state={isAwaitingAction? 'AWAITING ACTION': TaskState.Review} 
                  colorState={TaskState.Review}
                  size="large" 
                /> : 
                <img src={iconCortPng} alt="icon" className="paperPng icon-task-state" />
            ),
         /*    actionRight: (
              <Button
                className="button button-transparent"
                onClick={() => onHelpDocs()}
              >
                <QuestionCircleOutlined />
                Help docs
              </Button>
            ) */
          }}
          animationDirection="onRight"
          stepsTotal={2}
          currentStep={step}
          setStep={setStep}
          tracker={renderTracker()}
        >
          <section className="children AchPaymentForm">
            {step === 1 && (
              <Step1
                responsesStep1={responsesStep1}
                setStep={setStep}
                closeTask={() => setModalTaskVisible(false)}
                optionSelect={optionStep1Select}
                setOptionSelect={setOptionStep1Select}
              />
            )}
            {step === 2 && (
              <Step2
                responsesStep1={responsesStep1}
                optionStep1Select={optionStep1Select}
                setStep={setStep}
                closeTask={() => setModalTaskVisible(false)}
              />
            )}
          </section>
        </ModalTask>
      </EntityContext.Provider>
    </TaskContext.Provider>
  );
};
export default Insurance;
